import React, { PureComponent } from 'react';
import axios from 'axios';

import { NavLink } from 'react-router-dom';

import bg from '../images/menu.jpg';
import logo from '../images/logo-white.png';

class Menu extends PureComponent {

    state = {
        address: null,
        emailAddress: null,
        telephoneNumber: null
    }

    componentDidMount() {
        this.getContactDetails();
    }

    async getContactDetails() {
        const response = await axios.get(process.env.CMS_URL + '/getOptions');
        const data = response.data;

        this.setState({
            address: data.address,
            emailAddress: data.email_address,
            telephoneNumber: data.telephone_number
        });
    }

    render() {
        const { isMenuOpen } = this.props;
        const { address, emailAddress, telephoneNumber } = this.state;

        return (
            <div
                className={isMenuOpen ? 'menu __active' : 'menu'}
                style={{ backgroundImage: `url('${bg}')` }}
            >
                <a href="/" className="logo">
                    <img src={logo} alt="Cardiff University" />
                    <span className="sr-only">Cardiff University: How Good is my Job Quiz</span>
                </a>
                <nav className="menu-menu">
                    <ul>
                        <li>
                            <NavLink
                                exact
                                to="/"
                                activeStyle={{
                                    color: '#ce0538'
                                }}
                            >
                                Home
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                exact
                                to="/about"
                                activeStyle={{
                                    color: '#ce0538'
                                }}
                            >
                                About the Quiz
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                exact
                                to="/interesting-facts"
                                activeStyle={{
                                    color: '#ce0538'
                                }}
                            >
                                Interesting Facts
                            </NavLink>
                        </li>
                        <li>
                            <NavLink 
                                to="https://wiserd.ac.uk/project/ses/ses2024/"
                                style={{
                                    color: '#ce0538'
                                }}
                                target="_blank"
                            >
                                More About the Research
                            </NavLink>
                        </li>
                        <li>
                            <NavLink 
                                exact
                                to="/cookie-policy"
                                activeStyle={{
                                    color: '#ce0538'
                                }}
                            >
                                Cookie Policy
                            </NavLink>
                        </li>
                    </ul>
                </nav>

                <div className="menu-details d-none d-lg-flex">
                    <div className="menu-wrap">
                        { address && (
                            <div className="menu-address">
                                <div className="addressblock">
                                    <h3 className="addressblock-title">GET IN TOUCH</h3>
                                    <p className="addressblock-text" dangerouslySetInnerHTML={{__html: address}}/>                                                                            
                                </div>
                            </div>
                        )}
                        { emailAddress && (
                            <a className="menu-email" href={`mailto:${emailAddress}`}>
                                {emailAddress}
                            </a>
                        )}

                        { telephoneNumber && (
                            <a className="menu-tel" href={`tel:${telephoneNumber}`}>
                                {telephoneNumber}
                            </a>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js